// ABOUTME: Pure derived-value formulas for the breathing core's cycle ramp, countdown, ring sweep,
// ABOUTME: and wave amplitude (Issue #1943 spec section 2, ported from the v25 prototype's live formulas).

// Cycle ramp 3s->5s over the CURRENT round (restarts at 3s every new round): first quarter linear
// 3->3.5s, second 3.5->4s, third 4->5s, final quarter held at 5s, rounded to 2 decimals. This returns the ramp's
// instantaneous value for a given elapsed time; the swell animation applies it as a playbackRate (see swellPlaybackRate).
export function breathDurAt(elapsed: number, total: number): number {
  const x = total > 0 ? Math.min(1, Math.max(0, elapsed / total)) : 0;
  const dur = x < 0.25 ? 3 + (x / 0.25) * 0.5
    : x < 0.5 ? 3.5 + ((x - 0.25) / 0.25) * 0.5
    : x < 0.75 ? 4 + ((x - 0.5) / 0.25) * 1
    : 5;
  return Math.round(dur * 100) / 100;
}

// The swell animation always has a 3s duration; the ramp slows it by setting this as its playbackRate.
export const swellPlaybackRate = (elapsed: number, total: number) => 3 / breathDurAt(elapsed, total);

export function breathClock(left: number): string {
  const minutes = Math.floor(left / 60);
  const seconds = String(left % 60).padStart(2, '0');
  return `${minutes}:${seconds}`;
}

export function breathPct(total: number, left: number): string {
  const deg = total > 0 ? Math.round(((total - left) / total) * 360) : 0;
  return `${deg}deg`;
}

export function breathAmp(dur: number): number {
  return 1 - ((dur - 3) / 2) * 0.5;
}

export function canoeRideHeight(amp: number): number {
  return 39 - 30 * amp;
}
